<template>
  <div class="nuttrema-allergens-summary">

    <div v-if="allEmpty" class="nuttrema-allergens-summary__empty">
      <p class="empty__icon"><i class="fas fa-hand-heart"></i></p>
      <p class="empty__title">{{ $t('label.no_allergens_found') }}</p>
    </div>

    <div v-if="!_isEmpty(allergens.contains)" class="nuttrema-allergens-summary__list is-contains">
      <h4 class="mt-05 mb-025">{{ $t('label.contains') }} <i class="fas fa-allergies"></i></h4>
      <ul>
        <li v-for="allergen in _get(allergens, 'contains', [])" :title="allergen.tip || ''">
          {{ _get(allergen, 'name') }}
        </li>
      </ul>
    </div>

    <div v-if="!_isEmpty(allergens.may_contain)" class="nuttrema-allergens-summary__list is-may-contain">
      <h4 class="mt-05 mb-025">{{ $t('label.may_contain') }} <i class="fas fa-allergies"></i></h4>
      <ul>
        <li v-for="allergen in _get(allergens, 'may_contain', [])" :title="allergen.tip || ''">
          {{ _get(allergen, 'name') }}
        </li>
      </ul>
    </div>

    <div v-if="!_isEmpty(allergens.contains_no)" class="nuttrema-allergens-summary__list is-contains-no">
      <h4 class="mt-05 mb-025">{{ $t('label.contains_no') }} <i class="fas fa-allergies"></i></h4>
      <ul>
        <li v-for="allergen in _get(allergens, 'contains_no', [])" :title="allergen.tip || ''">
          {{ _get(allergen, 'name') }}
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
import { get, isNil, isEmpty } from 'lodash';

export default {
  name: 'nuttrema-allergens-summary',
  props: {
    allergens: {
      required: false,
      default: null,
    },
  },
  computed: {
    allEmpty() {
      const contains = get(this.allergens, 'contains', []);
      const mayContain = get(this.allergens, 'may_contain', []);
      const containsNo = get(this.allergens, 'contains_no', []);
      return isNil(this.allergens) || (isEmpty(contains) && isEmpty(mayContain) && isEmpty(containsNo));
    },
  },
};
</script>

<style lang="scss" scoped>
  @import './nuttrema-allergens-colors';

  .nuttrema-allergens-summary {

    .nuttrema-allergens-summary__list {
      margin-bottom: 1em;

      &.is-contains {
        color: $contains-color;
        // background: $contains-background;
        border-color: $contains-border-color;
      }

      &.is-may-contain {
        color: $may-contain-color;
        // background: $may-contain-background;
        border-color: $may-contain-border-color;
      }

      &.is-contains-no {
        color: $contains-no-color;
        // background: $contains-no-background;
        border-color: $contains-no-border-color;
      }

      h4 {
        font-size: 1rem;
        font-weight: 800;
        border-bottom-width: 2px;
        border-bottom-style: solid;
        i {
          float: right;
          margin: 0.35em 0.25em 0 0;
        }
      }

      ul {
        li {
          border-bottom-width: 1px;
          border-bottom-style: solid;
          padding: 0.15em 0.25em;

          &:last-child {
            border-bottom-style: none;
          }
        }
      }
    }

    .empty__icon {
      text-align: center;
      color: $contains-no-color;
      i {
        font-size: 2.5em;
      }
    }

    .empty__title {
      text-align: center;
      font-size: 1.15em;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/ui/allergens/nuttrema-allergens-summary.vue